import * as React from "react";
import { IValidation } from "@generation/core";
import { FileRow } from "./FileRow";
import { FileManagementFile } from "../../Interfaces/fileManagementFile";

interface FileListProps {
  files: FileManagementFile[];
  validate?: IValidation[];
  onDelete: (file: FileManagementFile, index: number) => void;
}
export const FileList = React.memo(function FileList(props: FileListProps) {
  if (!props.files.length) {
    return null;
  }
  return (
    <div>
      {props.files
        .filter((file) => !file.deleted)
        .map((file, index) => {
          return (
            <FileRow<FileManagementFile>
              key={file.referenceId}
              file={{ ...file, file: { name: file.fileName, size: file.file?.size ?? 0 } as unknown as File }}
              index={index}
              onDelete={(_file, index) => props.onDelete(file, index)}
              validate={file.id > 0 ? undefined : props.validate}
              showValidationMessageBelowFile={file.id === 0}
            />
          );
        })}
    </div>
  );
});
